import type { BarChartToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useBarChartTokens = (theme: Theme): BarChartToken => {
  const { color, component } = theme;
  const base = {
    color: color.primary,
    showAxis: false,
    radius: 4,
  };

  return merge({}, base, component?.barChart) as BarChartToken;
};
